/**
 * Endpoints for SIS API calls
 */
export enum Endpoint {
	authExists = '/rest/auth/exists',
	authLogin = '/rest/auth/login',
	authLogout = '/rest/auth/logout',
	employeeSSO = '/rest/oauth/entra_login',
	passwordComplexity = '/rest/auth/password-complexity',

	tokenRefresh = '/rest/oauth/access_token',
	resendVerify = '/rest/auth/reconfirm',
	user = '/rest/users',
	usersSearch = '/rest/users/search',
	usersRoleSearch = '/rest/users/role/search',
	usersMigrateGigya = '/rest/auth/exists',
	usersSendPasswordResetEmail = '/rest/auth/reset',
	usersRecoverPassword = '/rest/auth/recover',
	usersSendVerificationEmail = '/rest/auth/reconfirm',
	usersSetEmailVerification = '/rest/auth/confirm',
	usersSetNewPassword = '/rest/auth/set/password',
	usersDeleteUser = '/rest/users', // DELETE
	usersSuspendAccount = '/rest/users/suspend',
	usersUnsuspendAccount = '/rest/users/unsuspend',
	usersAcceptedTerms = '/rest/identity-admin/terms/user/%s/accepted-terms',
	usersAcceptTerms = '/rest/identity-admin/terms/user/%s/accept-terms',
	usersRevokeTerms = '/rest/identity-admin/terms/user/%s/revoke-terms',
	usersLocales = '/rest/utils/locales',
	usersTzs = '/rest/utils/tzs',
	usersCountries = '/rest/utils/enum?name=country',
	usersGenders = '/rest/utils/enum?name=gender',
	usersAvailableRoles = '/rest/users/roles/available', // Available roles that the logged in user can provision
	usersRoles = '/rest/users/roles', // Get/Add/Delete a particular user's roles
	usersRolesAll = '/rest/users/roles/all', // List all roles for search filter dropdown
	usersRolesSources = '/rest/users/roles/sources', // troubleshooting deeep dive into a user's roles
	usersUpdateAttributes = '/rest/users', // POST
	urlValidate = '/rest/identity-admin/url/validate',
	appkey = '/rest/identity-admin/oauthapp',
	apiDocumentation = '/rest/documentation',
	oauthAppTerms = '/rest/identity-admin/terms',
	termLocales = '/rest/identity-admin/utils/locales',
	clusters = '/rest/identity-admin/clusters',
	appVersions = '/rest/identity-admin/app-versions',


// below here belong under https://api.staging.specialized.com/bike-service/v2/

	brsJwtToken = '/cluster/useradmin/jwt',

	usersByEmail = '/users', // this is  https://api.staging.specialized.com/bike-service/v2/users - currently not used in staging and prod

	bikesBySerialNumber = '/specialized_bikes',
	bikesByIdentifier   = '/specialized_bikes/by_identifier',

	adminGetRegistrationInfo     = '/admin/get_registration_info',
	bikeRegistrations            = '/bike_registrations',
	bikeRegistrationsSpecialized = '/bike_registrations/specialized',

	transferRequests             = '/transfer_requests',
	transferRequestsForBikeId    = '/transfer_requests/for_bike_id',
	transfersRequestsOpen        = '/transfer_requests/open',
	transfersForSourceUser       = '/transfer_requests/for_source_user',
	transfersForDestinationEmail = '/transfer_requests/for_destination_email',
	transfersForTimePeriod       = '/transfer_requests/for_time_period'
}

/**
 * @param str reverse lookup of endpoint...
 */
export const reverseEndpoint = (val: string) => {
	const enumName = (Object.keys(Endpoint) as Array<keyof Endpoint>).find((k) => Endpoint[k] === val || val.indexOf(Endpoint[k]) === 0);

	return enumName ? Endpoint[enumName] : null;
};

/**
 * Check if an Endpoint needs credentials when calling that API
 * @param point the endpoint to check
 */
export function CredsEndPoint(ep: Endpoint): boolean {
	if (!ep) return true;

	switch (ep) {
		case Endpoint.tokenRefresh:
		case Endpoint.authLogin:
		case Endpoint.authExists:
		case Endpoint.resendVerify:
		case Endpoint.usersCountries:
		case Endpoint.usersGenders:
		case Endpoint.usersLocales:
		case Endpoint.usersSendPasswordResetEmail:
		case Endpoint.usersSendVerificationEmail:
		case Endpoint.usersRecoverPassword:
		case Endpoint.passwordComplexity:
		case Endpoint.employeeSSO:
			return false;
		default:
			return true;
	}
}
